import { ElementRef } from '@angular/core';
import { Attachment } from './models/attachment.model';
import { NgForm } from '@angular/forms';

export class System {

    // Properties
    static apiURL = {
        Student: location.protocol + '//' + location.host + System.getBaseLocation() + 'AppApi/TylerSIS/Student/',
        Counselor: location.protocol + '//' + location.host + System.getBaseLocation() + 'AppApi/TylerSIS/Counselor/',
        Admin: location.protocol + '//' + location.host + System.getBaseLocation() + 'AppApi/TylerSIS/Admin/',
        Shared: location.protocol + '//' + location.host + System.getBaseLocation() + 'AppApi/TylerSIS/Shared/',
        Classroom: location.protocol + '//' + location.host + System.getBaseLocation() + 'AppApi/TylerSIS/Classroom/',
        Reporting: location.protocol + '//' + location.host + System.getBaseLocation() + 'AppApi/TylerSIS/Reporting/',
        Management: location.protocol + '//' + location.host + System.getBaseLocation() + 'AppApi/TylerSIS/Management/',
        StateReporting: location.protocol + '//' + location.host + System.getBaseLocation() + 'AppApi/TylerSIS/StateReporting/',
        Health: location.protocol + '//' + location.host + System.getBaseLocation() + 'AppApi/TylerSIS/Health/',
        SpecialEd: location.protocol + '//' + location.host + System.getBaseLocation() + 'AppApi/TylerSIS/SpecialEd/'
    };
    static tokenURL = location.protocol + '//' + location.host + System.getBaseLocation() + 'token';
    static baseUrl = location.protocol + '//' + location.host + System.getBaseLocation();
    static junkDateString = '0001-01-01T00:00:00';
    static junkDate = new Date(System.junkDateString);
    static mailRegexp = /^\s*(?:[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[A-Za-z0-9-]*[A-Za-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])\s*$/;
    static phoneRegexp = /^(\(\d{3}\) )?(\d{3})-(\d{4})$/;
    static phoneTextMask = ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    static zipRegexp = /^\d{5}(?:-\d{4})?$/;
    static postalCodeRegexp = /[a-zA-Z]\d[a-zA-Z]\s\d[a-zA-Z]\d/;
    static twelveHourTimeRegexp = /^(0[1-9]|1[012]):[0-5]\d\s[apAP][mM]$/;
    // static twentyFourHourTimeRegexp = /^(0\d|1[012]|2[0123]):[0-5]\d(:[0-5]\d)?$/;
    // ONE-12279
    static twentyFourHourTimeRegexp = /^([01]\d|2[0-3]):?([0-5]\d)$/;
    static twelveHourTimeMask = [/[01]/, /\d/, ':', /[0-5]/, /\d/, ' ', /[apAP]/, /[mM]/];
    static twentyFourHourTimeMask = [/[012]/, /\d/, ':', /[0-5]/, /\d/];
    static paginatorPageSizes = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 500, 1000];
    static paginatorDefaultSize = 100;

    private static iso8601RegEx = /(19|20|21)\d\d([-/.])(0[1-9]|1[012])\2(0[1-9]|[12][0-9]|3[01])T(\d\d)([:/.])(\d\d)([:/.])(\d\d)/;

    static mimeTypes: string[] = [
        'text/html',
        'text/css',
        'text/xml',
        'image/gif',
        'image/jpeg',
        'image/jpg',
        'image/webp',
        'image/png',
        'video/mp4',
        'audio/x-m4a',
        'audio/mp3',
        'video/ogg',
        'audio/ogg',
        'video/webm',
        'audio/webm',
        'audio/wav',
        'application/xhtml+xml',
        'application/x-chrome-extension',
        'multipart/related',
        'application/pdf',
        'image/bmp',
        'image/x-icon',
        'image/vnd.microsoft.icon',
        'image/tiff',
        'image/x-xbitmap',
        'image/svg+xml',
        'text/xml',
        'text/plain'
    ];

    // Functions
    static isDateEqual(dateA: Date, dateB: Date) {
        return (!dateA && !dateB)
            || (
                dateA
                && dateB
                && dateA.toString() == dateB.toString()
            );
    }

    static removeIdFields(object: any) {
        // POST: removes the $id fields from an object
        if (object != null) {
            const keys = Object.keys(object);
            if (keys.includes('$id')) {
                delete object['$id'];
            }
            for (let i = 0; i < keys.length; i++) {
                if (typeof (object[keys[i]]) == 'object') {
                    System.removeIdFields(object[keys[i]]);
                }
            }
        }
    }

    static removeFromList<T>(list: T[], value: T) {
        const index = list.indexOf(value);
        if (index >= 0) {
            list.splice(index, 1);
        }
    }

    static createUniqueName(currentName: string, allNames: string[], excludedNames: string[] = []) {
        let newName = currentName;
        while (allNames.find(name => name == newName) || excludedNames.find(name => name == newName)) {
            newName = System.createNextName(newName);
        }
        return newName;
    }

    static createNextName(currentName: string) {
        // POST: create a new name with (#) appended to it
        const numberRegexp = /\(\d+\)/g;
        const matches = currentName.match(numberRegexp);
        let nextName = currentName;
        if (matches && matches.length > 0) {
            const lastMatch = matches[matches.length - 1];
            const indexOfNumber = nextName.lastIndexOf(lastMatch);
            const number = parseInt(
                lastMatch.substr(1, lastMatch.length - 1),
                10
            );
            nextName = nextName.slice(0, indexOfNumber) +
                '(' + (number + 1) + ')' +
                nextName.slice(indexOfNumber + lastMatch.length);
        } else {
            nextName += ' (1)';
        }
        return nextName;
    }

    static overlappingTimes(startA: string, endA: string, startB: string, endB: string, twelveHour = false) {
        if (twelveHour) {
            startA = this.convert12HourTimeTo24HourTime(startA);
            endA = this.convert12HourTimeTo24HourTime(endA);
            startB = this.convert12HourTimeTo24HourTime(startB);
            endB = this.convert12HourTimeTo24HourTime(endB);
        }
        const convertToDate = (timeString: string): Date => {
            const hours = Number.parseInt(timeString.charAt(0) + timeString.charAt(1), 10);
            const minutes = Number.parseInt(timeString.charAt(3) + timeString.charAt(4), 10);
            const date = new Date();
            date.setHours(hours);
            date.setMinutes(minutes);
            return date;
        };
        const dateStartA = convertToDate(startA);
        const dateEndA = convertToDate(endA);
        const dateStartB = convertToDate(startB);
        const dateEndB = convertToDate(endB);
        return this.overlappingDates(dateStartA, dateEndA, dateStartB, dateEndB);
    }

    static overlappingDates(startA: Date, endA: Date, startB: Date, endB: Date) {
        // POST: returns true  if the start and end of A overlap with the start and end of B
        return (
            (!(startA >= endB || endA <= startB))
            || (
                startB.toString() == startA.toString()
                && startA.toString() == endA.toString()
                && endA.toString() == endB.toString()
                )
        );
        // return (startA > startB && startA < endB)   // B --- A ---- B ---- A
        //     || (startB > startA && startB < endA)   // A --- B ---- A ---- B
        //     || (startA <= startB && endA >= endB)   // A --- B ---- B ---- A or AB --- BA
        //     || (startB <= startA && endB >= endA)   // B --- A ---- A ---- B or BA --- AB
        //     || (
        //         startB.toString() == startA.toString()
        //         && startA.toString() == endA.toString()
        //         && endA.toString() == endB.toString()
        //     );    // ABBA (we need this in scheduling to prevent unique key conflicts)
    }

    static validate12HourTime(timeString: string): boolean {
        return timeString.match(this.twelveHourTimeRegexp) != null;
    }

    static validate24HourTime(timeString: string): boolean {
        return timeString.match(this.twentyFourHourTimeRegexp) != null;
    }

    static convert24HourTimeTo12HourTime(timeString: string): string {
        if (this.validate24HourTime(timeString)) {
            let hours = Number.parseInt(timeString.charAt(0) + timeString.charAt(1), 10);
            const minutes = Number.parseInt(timeString.charAt(3) + timeString.charAt(4), 10);
            let meridian = '';
            if (hours >= 12) {
                meridian = 'PM';
            } else {
                meridian = 'AM';
            }
            if (hours == 0) {
                hours = 12;
            } else if (hours > 12) {
                hours -= 12;
            }
            let convertedTime = '';
            if (hours < 10) {
                convertedTime += '0' + hours.toString();
            } else {
                convertedTime += hours.toString();
            }
            convertedTime += ':';
            if (minutes < 10) {
                convertedTime += '0' + minutes.toString();
            } else {
                convertedTime += minutes.toString();
            }
            convertedTime += ' ' + meridian;
            return convertedTime;
        } else {
            return '';
        }
    }

    static convert12HourTimeTo24HourTime(timeString: string): string {
        if (this.validate12HourTime(timeString)) {
            let hours = Number.parseInt(timeString.charAt(0) + timeString.charAt(1), 10);
            const minutes = Number.parseInt(timeString.charAt(3) + timeString.charAt(4), 10);
            const meridian = timeString.charAt(6) + timeString.charAt(7);
            if (meridian.includes('P') && hours != 12) {
                hours += 12;
            }
            let convertedTime = '';
            if (hours < 10) {
                convertedTime += '0' + hours.toString();
            } else {
                convertedTime += hours.toString();
            }
            convertedTime += ':';
            if (minutes < 10) {
                convertedTime += '0' + minutes.toString();
            } else {
                convertedTime += minutes.toString();
            }
            convertedTime += ':00';
            return convertedTime;
        } else {
            return '';
        }
    }

    static forceUpdateValidity(form: NgForm) {
        // PRE: an ngForm
        // POST: updates the validity of each control
        setTimeout(() => {
            const controlKeys = Object.keys(form.controls);
            controlKeys.forEach(key => {
                form.controls[key].markAsTouched();
                try {
                    form.controls[key].updateValueAndValidity();
                } catch (error) {
                    console.log('Error while validating. Probably just a checkbox.');
                }
            });
        }, 10);
    }

    static roundDateUp(date: Date) {
        // PRE: a date to round up
        // POST: rounds the date up as close to the following day as possible
        if (date) {
            date.setHours(23);
            date.setMinutes(59);
            date.setSeconds(59);
            date.setMilliseconds(999);
        }
    }

    static roundDateDown(date: Date) {
        // PRE: a date to round down
        // POST: rounds the date down as close to the previous day as possible
        if (date) {
            date.setHours(0);
            date.setMinutes(0);
            date.setSeconds(0);
            date.setMilliseconds(0);
        }
    }

    static copyToClipboard(str: string) {
        const el = document.createElement('textarea') as HTMLTextAreaElement;
        el.value = str;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    }

    static isNumeric(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }

    static convertDateToUTC(value: string): Date {
        // PRE: a string that represents a time
        // POST: converts that string to a date in UTC time zone
        if (value != null) {
            let date = new Date(value);
            if (typeof (value) != 'object' && value.indexOf('Z') < 0 && value.length > 10) {
                value = value + 'Z';
                date = new Date(Date.parse(value));
            }
            else if (typeof (value) != 'object' && value.length <= 10) {
                const objDate = value.split('/');
                date = new Date(Number(objDate[2]), (Number(objDate[0]) - 1), Number(objDate[1]));
            }
            date = new Date(date.getTime() + (60000 * date.getTimezoneOffset()));
            return date;
        }
        else {
            return null;
        }
    }

    static htmlToText(text: any) {
        if (!text) {
            return '';
        }
        if (typeof text != 'string') {
            text = text.toString();
        }
        text = text.replace(/&nbsp;/g, ' ');
        text = text.replace(/&amp;/g, '&');
        text = text.replace(/&#39;/g, '\'');
        text = text.replace(/&quot;/g, '"');
        text = text.replace(/&#34;/g, '"');
        text = text.replace(/&lt;/g, '<');
        text = text.replace(/&#60;/g, '<');
        text = text.replace(/&gt;/g, '>');
        text = text.replace(/&#62;/g, '>');
        text = text.replace(/&#61;/g, '=');
        return text;
    }

    static textToHtml(html) {
        let text = '';
        if (html) {
            text = text + html;
        }
        text = text.replace(/</g, '&lt;');
        text = text.replace(/>/g, '&gt;');
        text = text.replace(/"/g, '&quot;');
        text = text.replace(/'/g, '&#39;');
        text = text.replace(/&/g, '&amp;');
        text = text.replace(/=/g, '&#61;');
        return text;
    }

    static xmlToText(text: any) {
        if (!text) {
            return '';
        }
        if (typeof text != 'string') {
            text = text.toString();
        }
        text = text.replace(/&amp;/g, '&');
        text = text.replace(/&#39;/g, '\'');
        text = text.replace(/&quot;/g, '"');
        text = text.replace(/&lt;/g, '<');
        text = text.replace(/&gt;/g, '>');
        text = text.replace(/<>/g, 'Not=');
        return text;
    }

    static textToXML(xml) {
        let text = '';
        if (xml) {
            text = text + xml;
        }
        text = text.replace(/</g, '&lt;');
        text = text.replace(/>/g, '&gt;');
        text = text.replace(/"/g, '&quot;');
        text = text.replace(/'/g, '&#39;');
        text = text.replace(/&/g, '&amp;');
        text = text.replace(/Not=/g, '&lt;&gt;');
        return text;
    }

    static numberMask(rawValue: string) {
        // PRE: a string for an input
        // POST: returns a mask for only number values
        // NOTE: this is to be used with angular2-text-mask
        const mask = [];
        for (let i = 0; i < rawValue.length; i++) {
            mask.push('\d');
        }
        return mask;
    }

    static currentTime(): string {
        // POST: returns a 12-hour string representation of the current time
        const currentDateTime = new Date();
        let currentHour = currentDateTime.getHours();
        const currentMinutes = currentDateTime.getMinutes();
        let am = true;
        if (currentHour >= 12) {
            am = false;
            currentHour -= 12;
        }
        return currentHour + ':' + (currentMinutes < 10 ? '0' + currentMinutes : currentMinutes) + ' ' + (am ? 'am' : 'pm');
    }

    static viewFileFromId(id: number, fileName: string, windowToUse?: Window) {
        // PRE: an ID and a file name. Optionally, a window to use.
        // POST: looks the attachment up and, if it is found, displays it
        const attachment = new Attachment();
        attachment.DocumentId = id;
        attachment.DocumentName = fileName;
        window.localStorage.setItem('studentAttachment', JSON.stringify(attachment));
        let newWindow = null;
        if (windowToUse) {
            newWindow = windowToUse;
        } else {
            newWindow = window.open(System.baseUrl + 'studentattachment');
        }
        if (newWindow) {
            newWindow.focus();
        }
    }

    static viewFileFromBase(dataBase64: string, fileType: string, fileName: string, windowToUse?: Window) {
        // PRE: a base64, a file type, and a file name of the displayed file. Optionally, a window to use.
        // POST: views the file in a new window. If a window is provided, it will use that one.
        //       If the file is too big or we can't show a new window, downloads the file instead
        if (this.checkEdge()) {
            this.saveFile(dataBase64, fileType, fileName);
        }
        else {
            try {
                const attachment = new Attachment();
                attachment.DocumentBase64 = dataBase64;
                attachment.DocumentMimeType = fileType;
                attachment.DocumentName = fileName;
                window.localStorage.setItem('studentAttachment', JSON.stringify(attachment));
                let newWindow = null;
                if (windowToUse && System.mimeTypes.filter(type => type == fileType).length > 0) {
                    newWindow = windowToUse;
                }
                else if (System.mimeTypes.filter(type => type == fileType).length > 0) {
                    newWindow = window.open(System.baseUrl + 'studentattachment');
                }
                if (newWindow) {
                    newWindow.focus();
                }
                else {
                    this.saveFile(dataBase64, fileType, fileName);
                }
            } catch (e) {
                this.saveFile(dataBase64, fileType, fileName);
            }
        }
    }

    static checkEdge() {
        const ua = window.navigator.userAgent;
        const edge = ua.indexOf('Edge/');
        return edge > 1;
    }

    static saveFile(dataBase64, fileType, fileName) {
        // PRE: a base64, a file type, and a file name to set up a download
        // POST: downloads the file from the browser
        const byteCharacters = atob(dataBase64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: fileType });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        document.body.appendChild(a);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
    }

    static saveTextToFile(filename: string, text: string) {
        const blob = new Blob([text], { type: 'text/plain' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        document.body.appendChild(a);
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
    }

    static getTableHeight(tableContainerRef: ElementRef): number {
        // PRE: a reference to the table's container
        // POST: returns the amount of space the table may take up
        // NOTE: this won't work if you have multiple dynamic elements one after the other; you'll need to adjust it
        const tableHeightString = window.getComputedStyle(tableContainerRef.nativeElement.offsetParent, null).getPropertyValue('padding-bottom');
        // tslint:disable-next-line:radix
        let tableHeight = -(Number.parseInt(tableHeightString.replace('px', '')));
        tableHeight -= tableContainerRef.nativeElement.offsetTop;
        if (tableContainerRef) {
            if (tableContainerRef.nativeElement.nextElementSibling) {
                tableHeight += tableContainerRef.nativeElement.nextElementSibling.offsetTop;
            } else {
                if (tableContainerRef.nativeElement.offsetParent.clientHeight < tableContainerRef.nativeElement.offsetParent.offsetHeight) {
                    tableHeight += tableContainerRef.nativeElement.offsetParent.clientHeight;
                } else {
                    tableHeight += tableContainerRef.nativeElement.offsetParent.offsetHeight;
                }
            }
        }
        return tableHeight;
    }

    static getTableWidth(tableContainerRef: ElementRef): number {
        // PRE: a reference to the table's container
        // POST: returns how much width the table may take up
        if (tableContainerRef) {
            return tableContainerRef.nativeElement.scrollWidth;
        }
    }

    static getElementHeight(element: ElementRef): number {
        // POST: returns an elements offsetHeight
        return element.nativeElement.offsetHeight;
    }

    static getBaseLocation() {
        if (location.host != 'localhost:4200') {
            const paths: string[] = location.pathname.split('/').splice(1, 1);
            const basePath: string = (paths && paths[0]) || '/';
            return '/' + basePath + '/';
        } else {
            return '/';
        }
    }

    static stripHTML = (str: string): string => {
        // POST: strips the HTML from a string
        return str ? str.replace(/(<(?:.|\n)*?>|&nbsp;)/gm, '') : '';
    }

    static toCamelCase = (str: string): string => {
        // POST: returns the string in camelCase
        if (!str) {
            return '';
        }
        return str.toString().replace(/(?:\b\w|\s)/g, function (letter: string, index: number) {
            if (letter.match(/\s/)) {
                return '';
            } else {
                return index == 0 ? letter.toLowerCase() : letter.toUpperCase();
            }
        });
    }

    static randomString = (length = 5): string => {
        // POST: generates a random string of the specified length
        return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, length);
    }

    static fnConverDate(data: any) {
        // POST: convert date string to date object if date string matches the regular expression.
        if (typeof data !== 'object') { return data; }

        for (const key in data) {
            if (!data.hasOwnProperty(key)) { continue; }

            const value = data[key];
            const type = typeof value;
            let match;
            if (type == 'string' && (match = value.match(System.iso8601RegEx))) {
                data[key] = new Date(value);
            }
            else if (type === 'object') {
                this.fnConverDate(value);
            }
        }
    }

    static convert = <T>(toConvert: Object, convertedTo: T): T => {
        // PRE: an object to convert and an object to convert to
        //  	The object converted to must have its properties defined
        //  	System is due to a limitation on javascript (it doesn't remember types at runtime)
        //  	convertedTo should also not be an important reference
        // POST: converts the first object into the second
        // NOTE: each object type you want suported has to be included in the for loop below.
        // 		 currently supports: Date, Array
        if (toConvert == null) {
            if (convertedTo) {
                return convertedTo;
            } else {
                return null;
            }
        }
        const convertedToProps = Object.getOwnPropertyNames(convertedTo);
        const toConvertProps = Object.getOwnPropertyNames(toConvert);
        for (let i = 0; i < convertedToProps.length; i++) {

            // If the object to be converted has that value ...
            if (toConvertProps.includes(convertedToProps[i])) {

                // If that is an array, convert each element that's an object
                if (Array.isArray(toConvert[convertedToProps[i]])) {
                    toConvert[convertedToProps[i]] = System.copyArray(toConvert[convertedToProps[i]]);
                }

                // If a date, convert to date
                let match;
                if ((System.getType(convertedTo[convertedToProps[i]]) == 'Date' &&
                    System.getType(toConvert[convertedToProps[i]]) != 'Date') ||
                    (System.getType(toConvert[convertedToProps[i]]) === 'String' && (match = toConvert[convertedToProps[i]].match(System.iso8601RegEx)))) {
                    toConvert[convertedToProps[i]] = new Date(toConvert[convertedToProps[i]]);
                }

                // If not, just maintain the value
            }

            // If the object does not have the converted value, add the value to the converted object
            else {
                toConvert[convertedToProps[i]] = convertedTo[convertedToProps[i]];
            }
        }
        return Object.assign(convertedTo, toConvert);
    }

    static copyObject = <T>(copiedObject: Object, conversionObject: T): T => {
        // PRE: the object to be copied and a blank object to copy to
        //  	The conversion object must have its properties defined
        //  	System is due to a limitation on javascript (it doesn't remember types at runtime)
        //  	conversionObject should also not be an important reference
        // POST: copies the object to the blank object
        // NOTE: System doesn't perform any type conversions
        //       each object type you want suported has to be included in the for loop below.
        // 		 currently supports: Date
        return System.convert<T>(JSON.parse(JSON.stringify(copiedObject)), conversionObject);
    }

    static copyArray = (copiedArray) => {
        // POST: copies the array into a new array
        const newArray = [];
        for (let i = 0; i < copiedArray.length; i++) {

            // If it's an array, copy that
            if (Array.isArray(copiedArray[i])) {
                newArray.push(System.copyArray(copiedArray[i]));
            }

            // If it's an object, convert it
            else if (typeof (copiedArray[i]) == 'object' && copiedArray[i] != null) {
                newArray.push(System.convert(copiedArray[i], Object.assign({}, copiedArray[i])));
            }

            // If it's not an object, just copy it
            else {
                newArray.push(copiedArray[i]);
            }
        }
        return newArray;
    }

    static insertAt = <T>(arr: T[], item: T, index: number): T[] => {
        // PRE: an array, an item to insert, and an index
        // POST: inserts the item at that position in the array
        let newArr = arr.splice(0, index);
        newArr.push(item);
        newArr = newArr.concat(arr);
        return newArr;
    }

    static isEqual = (a: Object, b: Object): boolean => {
        // PRE: two objects to compare
        // POST: determines if the two objects have equal values
        if (a == null || b == null) {
            return a == b;
        }
        const aProps = Object.getOwnPropertyNames(a);
        const bProps = Object.getOwnPropertyNames(b);
        if (aProps.length != bProps.length) {
            return false;
        }
        for (let i = 0; i < aProps.length; i++) {
            const propName = aProps[i];
            if (typeof a[propName] == 'object' && a[propName] != null) {
                if (typeof b[propName] != 'object' || b[propName] == null) {
                    return false;
                } else if (!System.isEqual(a[propName], b[propName])) {
                    return false;
                }
            } else if (a[propName] != b[propName]) {
                return false;
            }
        }
        return true;
    }

    static arrayEqual = (a: Array<any>, b: Array<any>): boolean => {
        // PRE: two arrays to compare
        // POST: determines if the two arrays are equal
        // NOTE: this is not a deep equality
        if (a == null || b == null) {
            return a == b;
        }
        if (a.length != b.length) {
            return false;
        }
        for (let i = 0; i < a.length; i++) {
            if (a[i] != b[i]) {
                return false;
            }
        }
        return true;
    }

    static getType = (a: object): string => {
        // POST: returns the name of the object
        if (a == null) {
            return '';
        } else {
            return a.constructor.name;
        }
    }

    static isValid(val: any): boolean {
        if (val != null && val !== undefined) {
            if (val.length != null) {
                if (val.length > 0) {
                    return true;
                }
            }
        }
        return false;
    }

    static isValidDate(d: Date | string): boolean {
        if (d instanceof Date) {
            return !isNaN(d.getTime());
        }
        else {
            const dt = new Date(d);
            return !isNaN(dt.getTime());
        }
    }

    static isEven(rowId) {
        return (rowId % 2) === 0;
    }

    static generateUUID(): string {
        let d = new Date().getTime(); // Timestamp
        let d2 = (performance && performance.now && (performance.now() * 1000)) || 0; // Time in microseconds since page-load or 0 if unsupported
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = Math.random() * 16; // random number between 0 and 16
            if (d > 0) {// Use timestamp until depleted
                // tslint:disable-next-line:no-bitwise
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            } else {// Use microseconds since page-load if supported
                // tslint:disable-next-line:no-bitwise
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }
            // tslint:disable-next-line:no-bitwise
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    }
}
